import React, { Component } from 'react';
import LogoWhite from './../../logo-proximus-white.png';
import Logo from './../../logo-proximus.png';
import Banner from './../../images/ad-300x250.jpg';

export class Interstitial extends Component {

    getAdImage() {
        var adImage = this.props.fieldValues.adImage;
        if (adImage !== null && Image !== "") {
            return adImage;
        }
        return Banner;
    }

    render() {
        return(
            <div style={{height: '100%', width: '100%'}}>
                    <div className="adGroup" style={{backgroundImage: 'url(' + this.getAdImage() + ')'}}>
                    </div>
                {(this.getAdImage()!== undefined && this.getAdImage()!== '') ?
                    <p style={{
                        textAlign: 'center',
                        position: 'relative',
                        top: '25%'
                    }}>{this.props.showMessage('message_15_01')}<br/>{this.props.showMessage('message_15_02')}</p>:''
                }
            </div>
        )
    }
}


// WEBPACK FOOTER //
// ./src/components/preview/Interstitial.jsx